export const API_ENDPOINTS = {
  refreshToken: "/user/refreshToken",
  login: "/user/login",
  changestatus: "/user/update",
  unMuteUser: "/user/unmute-user",
  muteUser: "/user/mute-user",
  markAsUnread: "/messages/message-unread",
  addFavApi: "/favouriteLists/add",
  unFavApi: "/favouriteLists/removeFromFavourite",
  closeConversationApi: "/chatList/close-conversation",
  getUserById: "/user/getUserById",
  getmessage: "/messages/get-message",
  ssoLoginApi: "/user/redirectToBack",
  unMuteUser: "/user/unmute-user",
  muteUser: "/user/mute-user",
  markAsUnread: "/messages/message-unread",
  closeConversationApi: "/chatList/close-conversation",
  unMuteChannel: "/user/unmute-channel",
  muteChannel: "/user/mute-channel",
  seenChannelMessage: "/messages/channel/channel-message-seen",
  favouriteChannelApi: "/favouriteLists/channel/add",
  getChannelList: "/channels/get",
  unreadThreads: "/messages/getUnreadThread",
  unreadThreadsCount: "/messages/getUnreadThreadCounts",
  getSearchUserList: "/user/search-user",
  userSuggestions: "/user/user-suggestions",
  getChatList: "/chatList/get",
  addUserInChatList: "/chatList/add",
  getUserDetail: "/user/getUserById",
  addFavApi: "/favouriteLists/add",
  getFavApi: "/favouriteLists/get",
  unFavApi: "/favouriteLists/removeFromFavourite",
  unChannelFavApi: "/favouriteLists/channel/remove",
  unSeenMessageApi: "/messages/message-seen",
  unreadChannelMessageApi: "/channels/message-unread",
  searchChannelApi: "/user/search-user-channel",
  handlecreatechannel: "/channels/add",
  addMemberChannel: "/channels/addMember",
  leaveChannelApi: "/channels/leaveChannel",
  getNotificationChannels: "/channels/notification/get",
  sendMessage: "/messages/send-message",
  fileUpload: "/files/upload",
  messagePin: "/messages/message-pin",
  messageReaction: "/messages/message-reactionV2",
  messageDelete: "/messages/delete",
  messageReactionRemove: "/messages/message-reaction-removeV2",
  addMemberChannel: "/channels/addMember",
  leaveChannelApi: "/channels/leaveChannel",
  sendmessage: "/messages/send-message",
  sendChannelMessage: "/messages/channel/send-message",
  fileUpload: "/files/upload",
  getFilesListing: "/messages/getFilesListing",
  addfavourite: "/favouriteLists/add",
  removeFromFavourite: "/favouriteLists/removeFromFavourite",
  unMuteUser: "/user/unmute-user",
  muteUser: "/user/mute-user",
  addMemberChannel: "/channels/addMember",
  leaveChannelApi: "/channels/leaveChannel",
  getReplies: "/messages/get-replies",
  sendChannelMessage: "/messages/channel/send-message",
  sendmessage: "/messages/send-message",
  reactOnMessage: "/messages/message-reaction",
  deleteReactionOnMessage: "/messages/message-reaction-remove",
  pinChatMessage: "/messages/message-pin",
  delete_chat_message: "/messages/delete",
  sendmessage: "/messages/send-message",
  sendChannelMessage: "/messages/channel/send-message",
  fileUpload: "/files/upload",

  //new
  searchUserChannel: "/user/search-user-channel",
  getMessageById: "/messages/getMessageById",
  getReplies: "/messages/get-replies",
  getChannel: "/channels/getChannel",
  getChannelMembers: "/channels/getChannelMembers",
  getChannelMessage: "/messages/channel/get-message",
  createPoll: "/messages/channel/poll/create",
  votePoll: "/messages/channel/poll",
  closePoll: "/messages/channel/poll",
  editPoll: "/messages/channel/poll",
  sendChannelMessage: "/messages/channel/send-message",
  getPinnedMessageChannel: "/messages/channel/get-pinned-message-for-channel",
  getFileListingChannel: "/messages/channel/getFilesListingForChannel",
  addFavouriteChannel: "/favouriteLists/channel/add",
  removeFavouriteChannel: "/favouriteLists/channel/remove",
  unmuteChannel: "/user/unmute-channel",
  muteChannel: "/user/mute-channel",

  changeMemberRole: "/channels/toggleAdmin",
  updateChannel: "/channels/update",
  leaveChannel: "/channels/leaveChannel",
  removeMemberFromChannel: "/channels/removeMember",
  messageSeen: "/messages/message-seen",
  messageSeenChannel: "/messages/channel/channel-message-seen",
  replyMessageSeen: "/messages/reply-message-seen",
  getAllUser: "/user/getUsers",
  searchMessage: "/messages/search",
  jumpToMessage: "/messages/get-message-jump",
  getUnreadThread: "/messages/getUnreadThread",
  getNotificationChannelMessage: "/messages/notification/channel/get-message",
  markNotificationSeen: "/messages/notification/seen",
  markAllNotificationsSeen: "/messages/seenAllNotifications",
  getNotificationVisibleTo: "/messages/notification",   // append /:messageId/visible-to
  archivedUserSuggestions: "/user/archived-user-suggestions",
  searchArchivedUserList: "/user/search-archived-user",
  getApiLogs: "/apiLogs",
};
